import * as React from "react";
import { TypographyBox } from "./style";
export interface TypographyProps {
	positionId: string;
	content: string;
	bgColor?: string;
}
export default class WebTypography extends React.PureComponent<TypographyProps, {}> {
	render() {
		const { content, bgColor, positionId } = this.props;
		return (
			<TypographyBox id={positionId} color={bgColor || "#fff"}>
				<div dangerouslySetInnerHTML={{ __html: content }} />
			</TypographyBox>
		);
	}
}
